import { createStore, persist, thunk, Thunk } from 'easy-peasy';
import orderStoreModel, { OrderStoreModel } from './dialog/order.dialog.store';
import loginStoreModel, { LoginStoreModel } from './login/login.store';
import i18 from 'i18next';
import suggestStoreModel, {
  SuggestStoreModel,
} from './dialog/suggest.dialog.store';
import deliveryFiltersStoreModel, {
  DeliveryFiltersStoreModel,
} from './features/analytics/delivery-filters.store';
import serviceWorkerStoreModel, {
  ServiceWorkerStoreModel,
} from './dialog/service-worker.dialog.store';
import attachStoreModel, {
  AttachStoreModel,
} from './dialog/attach-response.dialog.store';
import { QueryClient } from 'react-query';
import preferencesModel, { PreferencesModel } from './preferences';
import userFeedbackDialogModel, {
  UserFeedbackDialogModel,
} from './user-feedback';
import supportInfoPopupModel, {
  SupportInfoPopupModel,
} from './support-info-popup';
import workflowEditorModel, {
  WorkflowEditorModel,
} from '../features/workflows/store/workflow-editor.store';

export interface IStoreModel {
  dialogs: {
    order: OrderStoreModel;
    suggest: SuggestStoreModel;
    serviceWorker: ServiceWorkerStoreModel;
    attach: AttachStoreModel;
  };
  features: {
    analytics: {
      deliveryFilters: DeliveryFiltersStoreModel;
    };
  };
  login: LoginStoreModel;
  start: Thunk<IStoreModel>;
  preferences: PreferencesModel;
  userFeedbackDialog: UserFeedbackDialogModel;
  supportInfoPopup: SupportInfoPopupModel;
  workflowEditor: WorkflowEditorModel;
}

export const storeModel: IStoreModel = {
  dialogs: {
    order: orderStoreModel,
    suggest: suggestStoreModel,
    serviceWorker: serviceWorkerStoreModel,
    attach: attachStoreModel,
  },
  features: {
    analytics: {
      deliveryFilters: deliveryFiltersStoreModel,
    },
  },
  login: loginStoreModel,
  start: thunk(async (actions) => {
    await actions.login.start();
  }),
  preferences: preferencesModel,
  userFeedbackDialog: userFeedbackDialogModel,
  supportInfoPopup: supportInfoPopupModel,
  workflowEditor: workflowEditorModel,
};

export interface Injections {
  intl: typeof i18;
  queryClient: QueryClient;
}

export const STORE_VERSION = 3;

// `workflowEditor` fica fora do persist: o editor tem backup próprio em
// localStorage (`useDraftBackup`) e serializar grafo + 50 snapshots de undo
// a cada action travava a tela.
export const createStoreWithInjections = (injections: Injections) =>
  createStore(persist(storeModel, { deny: ['workflowEditor'] }), {
    injections,
    name: 'abbiamo-dashboard-store',
    version: STORE_VERSION,
  });

// export const createDefinedStore = () => createStore(storeModel);
